import * as React from 'react';
import { Image } from '../../uiComponents/layout/Image';

export interface KonkurrencePlaceringProps {
    placering: number;
}

export function KonkurrencePlacering(props: KonkurrencePlaceringProps) {
    return (
        <div className='placering-image-wrapper'>
            <Image className='placering-image' source='placering.png' />
            <p className='placering'>{props.placering}</p>
        </div>
    );
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/Scoreboard/KonkurrencePlacering.tsx